<app-container>
  <mat-card>
    <mat-card-content>
      <h1 class="text-center">Reset Password</h1>
      <form
        [formGroup]="form"
        (ngSubmit)="submitResetPassword()"
        mat-card-content
        *ngIf="!passwordReset; else passwordResetSuccess"
      >
        <div class="grid gap-md w-1/2 mx-auto m-1xl">
          <div>
            <label>Password</label>
            <mat-form-field class="w-full">
              <input matInput type="password" placeholder="Password" formControlName="password" />
            </mat-form-field>
          </div>

          <div class="form-group text-center mt-5">
            <button class="btn btn-primary">Reset my Password</button>
          </div>
        </div>
      </form>
      <ng-template #passwordResetSuccess>
        <div class="grid gap-md w-1/2 mx-auto m-1xl text-center">
          <p>
            Your password has been reset! You may now
            <a [routerLink]="['/login']">Login</a>.
          </p>
        </div>
      </ng-template>
    </mat-card-content>
  </mat-card>
</app-container>
